/* TODO: t() */
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';

import { ADDON_OPTIONS } from '../../../../support/constants/addons';

import LoadingIndicator from '../../../uiold/LoadingIndicator';
import { RadioGroup, RadioItem } from '../../../uiold';

import IndexedList from '../../../../support/shared/IndexedList';
import { Market } from '../../../../types/shared/Market';
import {
  VendorAddons,
  VendorAddonStatus,
  AddonDatesByMarket,
} from '../../../../types/shared/Vendor';
import { AddonElementDefinition } from '../../../../types/shared/FormFieldDefinition';
import { Addon } from '../../../../types/shared/Addon';

import FormField from '../helpers/FormField';
import { AddonMarketDateSelector } from './AddonMarketDateSelector';

type UpstreamProps = Omit<
  React.ComponentProps<typeof FormField>,
  'children' | 'definition'
>;

type Props = UpstreamProps & {
  readOnly?: boolean;
  invoiceView?: boolean;
  definition: AddonElementDefinition;
  markets?: IndexedList<Market> | null | undefined;
  addons?: Map<string, Addon> | null | undefined;
  onChange?: (id: string, value: VendorAddons) => void;
  value?: VendorAddons;
};

type State = {
  addonStatus: VendorAddonStatus;
  selections: ObjectOf<Array<string>>;
  visibleMarkets: Props['markets'];
};

class AddonElementFormView extends Component<Props, State> {
  state = {
    addonStatus: this.props.value?.status || 'No',
    selections: this.props.value ? toSelections(this.props.value.dates) : {},
    visibleMarkets: this.props.markets,
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.markets !== this.props.markets && this.props.markets) {
      this.setState({
        visibleMarkets: this.props.markets.filter(
          (market) => market.hidden !== true,
        ),
      });
    }
  }

  render() {
    let { props } = this;
    return <FormField {...props}>{this._renderField()}</FormField>;
  }

  _renderField = () => {
    let { definition, onChange, readOnly, invoiceView } = this.props;
    let { addonStatus, selections, visibleMarkets } = this.state;
    if (!visibleMarkets) {
      return <LoadingIndicator />;
    }
    if (definition.hidden && !readOnly && !invoiceView) {
      return null;
    }
    return (
      <View>
        <View style={styles.rowFlex}>
          <RadioGroup
            selectedValue={addonStatus}
            alignHorizontal
            onChange={(value) => {
              if (readOnly) {
                return;
              }
              let addonStatus = value as VendorAddonStatus;
              this.setState({ addonStatus });
              onChange?.(
                definition.id,
                toValue(
                  definition.id,
                  visibleMarkets?.toArray() || [],
                  addonStatus,
                  selections,
                ),
              );
            }}
          >
            {ADDON_OPTIONS.map((option, i) => {
              return (
                <RadioItem
                  key={i}
                  tabIndex={readOnly ? -1 : undefined}
                  value={option.value}
                  title={option.title}
                />
              );
            })}
          </RadioGroup>
        </View>
        {addonStatus === 'Partial' && !readOnly ? (
          visibleMarkets.length === 0 ? (
            <div>No markets to show</div>
          ) : (
            visibleMarkets.mapToArray((market) => {
              let selectedDates = selections[market.id] || [];
              return (
                <AddonMarketDateSelector
                  key={market.id}
                  status={addonStatus}
                  market={market}
                  availableDates={market.dates}
                  selectedDates={selectedDates}
                  onChange={(newSelectedDates) => {
                    let newSelections = {
                      ...selections,
                      [market.id]: newSelectedDates,
                    };
                    this.setState({ selections: newSelections });
                    onChange?.(
                      definition.id,
                      toValue(
                        definition.id,
                        visibleMarkets?.toArray() || [],
                        addonStatus,
                        newSelections,
                      ),
                    );
                  }}
                />
              );
            })
          )
        ) : null}
      </View>
    );
  };

  getValue = () => {
    let { definition } = this.props;
    let { addonStatus, selections, visibleMarkets } = this.state;
    return toValue(
      definition.id,
      visibleMarkets?.toArray() || [],
      addonStatus,
      selections,
    );
  };
}

function toSelections(datesByMarket: AddonDatesByMarket) {
  return Object.fromEntries(
    Object.entries(datesByMarket).map(([marketId, dates]) => [
      marketId,
      Object.keys(dates),
    ]),
  );
}

function toValue(
  id: string,
  markets: Array<Market>,
  addonStatus: VendorAddonStatus,
  selections: ObjectOf<Array<string>>,
) {
  let datesByMarket: AddonDatesByMarket = {};
  for (let market of markets) {
    let selectedDates = selections[market.id] || [];
    let datesObj = Object.fromEntries(selectedDates.map((date) => [date, 1]));
    datesByMarket[market.id] = datesObj;
  }
  return { addonId: id, status: addonStatus, dates: datesByMarket };
}

let styles = StyleSheet.create({
  rowFlex: { flexDirection: 'row' },
});

export default AddonElementFormView;
